import { Navbar, Nav } from "react-bootstrap";
import { useAssessments } from "../context/assessment-provider";
import { getSubjectName } from "../assessments/getsubjectname";
import "./assessment-subheader.scss";

function AssessmentSubheader() {
  const { subject, setSubject, subjects } = useAssessments();

  const activeSubject = subjects.includes(subject) ? subject : "All";
  return (
    <Navbar className="assessment-navbar" aria-label="Assessment Subjects">
      <div role="tablist" className="d-flex" aria-labelledby="subheader-title">
        <h2 id="subheader-title" className="visually-hidden">
          Assessment Subjects
        </h2>
        <Nav.Item
          as="button"
          role="tab"
          aria-selected={activeSubject === "All"}
          className={`assessment-subject me-3 ${activeSubject === "All" ? "underline" : ""}`}
          onClick={() => {
            setSubject("All");
          }}
        >
          All
        </Nav.Item>
        {subjects.map((sub) => (
          <Nav.Item
            as="button"
            key={sub}
            role="tab"
            aria-selected={sub === activeSubject}
            className={`assessment-subject mx-3 ${sub === activeSubject ? "underline" : ""}`}
            onClick={() => {
              setSubject(sub);
            }}
          >
            {getSubjectName(sub)}
          </Nav.Item>
        ))}
      </div>
    </Navbar>
  );
}

export default AssessmentSubheader;
